
( function () {

	/** If true, injects the GTM script inside the main window. If false, GTM will only be available in the iframe window. */
	let START_GTM = false;

	/** If true, dataLayer events will be pushed to the GTM in main window. If false, dataLayer events will be pushed only in the iframe window. */
	let PUSH_DATALAYER = false;

	/** If true, dataLayer events will be logged in main window. */
	let DEBUG_MODE = true;

	// Listen on pixel cross-frame messages.
	async function startListeningToPixelMessages() {

		// if ( "cookieStore" in window ) {
		// 	// If GTM debug mode is detected, push data layer events in the main window.
		// 	cookieStore.get( "__TAG_ASSISTANT" ).then( tagAssistantValue => {
		// 		if ( tagAssistantValue !== null ) {
		// 			console.info( 'PixelIntegr', ' - Tag assistant detected, switching to window mode' );
		// 			PUSH_DATALAYER = true;
		// 		}
		// 	} )
		// }

		PUSH_DATALAYER = true;

		if ( DEBUG_MODE ) {
			console.debug( 'PixelIntegr', ' - Started', { START_GTM, PUSH_DATALAYER, DEBUG_MODE } );
		}
		
		window.dataLayer ??= [];

		window.addEventListener( "message", ( event ) => {
			try {
				if ( event.isTrusted && event.data && typeof event.data === 'string' && event.data.trim()[ 0 ] === '{' ) {
					const json = JSON.parse( event.data );
					if ( json.type === 'pixel-startup' ) {
						if ( DEBUG_MODE ) {
							console.info( 'PixelIntegr', ' - GTM started on ', json.gtmId );
						}
						if ( START_GTM ) {
							const { gtmId } = json;
							const gtmScript = document.createElement( 'script' );
							gtmScript.async = '';
							gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${ gtmId }`;
							firstScript.parentNode.insertBefore( gtmScript, firstScript );
						}
					} else if ( json.type === 'pixel-data' ) {
						if ( DEBUG_MODE ) {
							console.info( 'PixelIntegr', ' - Data received:', json.evt );
						}
						if ( PUSH_DATALAYER ) {
							window.dataLayer.push( json.evt );
						}
					}
				}
			} catch ( e ) {
				console.error( 'PixelIntegr', ' - Failed to parse message', event, e );
			}
		} );
	}

	// Listen on theme events
	async function startListeningToCustomEvents() {

		if ( window?.Shopify?.analytics?.publish === undefined )
			return;

		const { country, locale: language, analytics } = window.Shopify;

		const pathname = location.pathname;

		const analyticsPublish = ( evtName, args = {} ) => {
			analytics.publish( evtName, { ...args, country, language } );
		}

		// STORE LOCATOR
		if ( pathname.includes( '/pages/' ) ) {
			window.addEventListener( 'click', evt => {
				const { target } = evt;
				if ( target.classList.contains( 'pixel-target' ) && target.dataset.pixelCta ) {
					const { storeName, storeAddress, pixelCta: cta } = target.dataset;
					analyticsPublish( "custom_store_locator", { storeName, storeAddress, cta } );
				}
			} );
		}

		// LOGIN PAGE
		if ( pathname.includes( '/account/login' ) ) {
			document.querySelector( 'form#customer_login' )?.addEventListener( 'submit', evt => {
				const form = evt.target;
				const formData = new FormData( form );
				analyticsPublish( "custom_login", { email: formData.get( 'customer[email]' ) } );
			} );
		}

		document.querySelector( 'form.newsletter-form' )?.addEventListener( 'submit', evt => {
			const form = evt.target;
			const formData = new FormData( form );
			analyticsPublish( "custom_newsletter", { email: formData.get( 'contact[email]' ) } );
		} );

	}

	startListeningToPixelMessages();
	startListeningToCustomEvents();

} )();
